import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './SearchBar.css'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { fetchRelaysData } from 'src/api/api'

const SearchBar: React.FC = () => {
  const navigate = useNavigate()
  let location = useLocation()

  const [query, setQuery] = useState('')
  const [isSearchLoading, setIsSearchLoading] = useState(false)

  const handleSearch = (event: any) => {
    event.preventDefault()
    try {
      setIsSearchLoading(true)
      fetchRelaysData({ search_term: query }).then((response) => {
        const searchResult = response.data.data

        if (searchResult.length === 1) {
          navigate(`/relays/${searchResult[0].id}`)
        } else if (!!query) {
          navigate(`/relays?search_term=${query}`)
        }
      })
    } catch (e: any) {
      console.error(e)
    } finally {
      setIsSearchLoading(false)
    }
  }

  useEffect(() => {
    setQuery('')
  }, [location.pathname])

  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-input"
        placeholder="Search tx hash or address..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        disabled={isSearchLoading}
        autoComplete="off"
        enterKeyHint="search" // helps mobile keyboards show the right button
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
      />
      <button className="search-icon-button" onClick={handleSearch}>
        <MagnifyingGlassIcon className="search-icon"/>
      </button>
    </div>
  )
}

export default SearchBar
